import * as THREE from 'three'
import { Entity } from './Entity'
import { SimplePoseSmoother } from '../extras/SimplePostSmoother'

export class EditorRemote extends Entity {
  constructor(client, data) {
    super(client, data)

    this.root = new THREE.Object3D()
    this.root.position.fromArray(data.p)
    this.root.quaternion.fromArray(data.q)
    this.client.graphics.scene.add(this.root)

    this.box = new THREE.Mesh(new THREE.BoxGeometry(0.5, 0.5, 0.5), new THREE.MeshBasicMaterial({ color: 'white' }))
    this.root.add(this.box)

    this.rootLerp = new SimplePoseSmoother()

    // this.rig = new THREE.Object3D()
    // this.rig.position.fromArray(data.position)
    // this.camera = this.client.graphics.camera
    // this.camera.position.set(0, 0, 0)
    // this.rig.add(this.camera)
    this.client.setHot(this, true)
    this.unregisterVoice = this.client.media.registerEntity(this)
  }

  modify(data) {
    if (data.hasOwnProperty('p')) {
      this.rootLerp.push(data.p, data.q)
    }
  }

  update(delta) {
    this.rootLerp.sample(this.root.position, this.root.quaternion)
  }

  getVoiceTransform(pos, qua) {
    pos.copy(this.root.position)
    qua.copy(this.root.quaternion)
  }

  setVoiceActive(active) {
    // ...
  }

  destroy() {
    this.client.setHot(this, false)
    this.unregisterVoice()
    this.unregisterVoice = null
    this.client.graphics.scene.remove(this.root)
    this.box.geometry.dispose()
    this.box.material.dispose()
  }
}
